import type { RootState } from 'src/redux/types';

export interface CommonOptionsType {
  waitMode?: 'debounce' | 'throttle' | 'none';
  useRedux?: boolean;
  wait?: number;
}

export const LEADING = true;
export const DEBOUNCE_WAIT_NUM = 20;
export const THROTTLE_WAIT_NUM = 30;

export interface CommonOptionsType {
  waitMode?: 'debounce' | 'throttle' | 'none';
  useRedux?: boolean;
  wait?: number;
  useRx?: boolean;
}

export interface ObservableStoreProps {
  dep: any[];
  opt?: CommonOptionsType & {
    obsSelectBlocks?: {
      blockId?: string;
      viewId?: string;
      syncId?: string;
    }[];
    obsSelectCell?: {
      recordId?: string;
      propertyId?: string;
      viewId?: string;
      groupValue?: string;
    }[];
    obsSimpleTable?: boolean;
    log?: boolean;
  };
}

export type ObservableStoreSelector<T> = (store: ObservableStore) => T;

export interface ObservableStore {
  blocks: RootState['blocks'];
  discussions: RootState['discussions'];
  comments: RootState['comments'];
  collectionViews: RootState['collectionViews'];
  /** 必须传入第三个参数 `obsSelectBlocks` 指定数据内容 */
  selectedBlocks: RootState['ui']['selectedBlocks'];
  /** 必须传入第三个参数 `obsSelectCell` 指定数据内容 */
  selectedCells: RootState['ui']['selectedCells'];
  /** 必须传入第三个参数 `obsSimpleTable` 为 `true`*/
  simpleTable: RootState['simpleTable'];
}
